import React from 'react'
import GridWrapper from '../components/OurServices/GridWrapper'
import { howItWorksData } from '../constants/data'

function HowItWorks() {
  return (
    <>
    <div className="h-1 w-full bg-main"></div>
      <div className="py-5 bg-gray-100">
        <h1 className="uppercase text-sm tracking-[4px]  mb-5 text-center"> How It Works</h1>
        <GridWrapper gridCols="lg:grid-cols-5" data={howItWorksData} isRightArrow={false} imgSize={"w-20 h-20"} mainSize={"text-base font-semibold"} />
      </div>
    </>
  )
}

export default HowItWorks